var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdCardHXs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7164_15165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91545 3.9599C2.8234 3.9599 2.74878 4.03452 2.74878 4.12657V13.4599C2.74878 13.5519 2.8234 13.6266 2.91545 13.6266H14.9154C15.0075 13.6266 15.0821 13.5519 15.0821 13.4599V4.12657C15.0821 4.03452 15.0075 3.9599 14.9154 3.9599H2.91545ZM1.74878 4.12657C1.74878 3.48223 2.27111 2.9599 2.91545 2.9599H14.9154C15.5598 2.9599 16.0821 3.48223 16.0821 4.12657V13.4599C16.0821 14.1042 15.5598 14.6266 14.9154 14.6266H2.91545C2.27111 14.6266 1.74878 14.1042 1.74878 13.4599V4.12657Z",
    fill: "#2D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.74878 7.79323C4.74878 6.78072 5.5696 5.9599 6.58211 5.9599C7.59462 5.9599 8.41545 6.78072 8.41545 7.79323C8.41545 8.80574 7.59462 9.62657 6.58211 9.62657C5.5696 9.62657 4.74878 8.80574 4.74878 7.79323ZM6.58211 6.9599C6.12189 6.9599 5.74878 7.33301 5.74878 7.79323C5.74878 8.25346 6.12189 8.62657 6.58211 8.62657C7.04234 8.62657 7.41545 8.25346 7.41545 7.79323C7.41545 7.33301 7.04234 6.9599 6.58211 6.9599Z",
    fill: "#2D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08211 11.1266C4.08211 9.74586 5.2014 8.62657 6.58211 8.62657C7.96282 8.62657 9.08211 9.74586 9.08211 11.1266C9.08211 11.4027 8.85825 11.6266 8.58211 11.6266C8.30597 11.6266 8.08211 11.4027 8.08211 11.1266C8.08211 10.2981 7.41054 9.62657 6.58211 9.62657C5.75369 9.62657 5.08211 10.2981 5.08211 11.1266C5.08211 11.4027 4.85825 11.6266 4.58211 11.6266C4.30597 11.6266 4.08211 11.4027 4.08211 11.1266Z",
    fill: "#2D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74878 7.4599C9.74878 7.18376 9.97264 6.9599 10.2488 6.9599H12.9154C13.1916 6.9599 13.4154 7.18376 13.4154 7.4599C13.4154 7.73604 13.1916 7.9599 12.9154 7.9599H10.2488C9.97264 7.9599 9.74878 7.73604 9.74878 7.4599Z",
    fill: "#2D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4154 10.1266C10.4154 9.85042 10.6393 9.62657 10.9154 9.62657H12.9154C13.1916 9.62657 13.4154 9.85042 13.4154 10.1266C13.4154 10.4027 13.1916 10.6266 12.9154 10.6266H10.9154C10.6393 10.6266 10.4154 10.4027 10.4154 10.1266Z",
    fill: "#2D2943"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7164_15165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.915527 0.793213)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCardHXs);
export default __webpack_public_path__ + "static/media/id-card-h-xs.26b6ad28.svg";
export { ForwardRef as ReactComponent };